export default [
  {
    path: "/aiMatch",
    name: "aiMatch",
    meta: {
      title: "AI做单",
      requireAuth: true
    },
    component: () => import("./aiMatch.vue")
  },
  {
    path: "/aiMatch/matchDetail/:sourceId",
    name: "matchDetail",
    meta: {
      title: "AI做单"
    },
    component: () => import("./matchDetail.vue")
  },
  {
    path: "/aiMatch/recommendDetail/:sourceId",
    name: "recommendDetail",
    meta: {
      title: "AI做单"
    },
    component: () => import("./recommendDetail.vue")
  }
];
